export enum EnumTipoPerfil {
    Operador = 0,
    Cliente = 1,
}